import { getCookieOrSessionStorage, setCookieOrSessionStorage } from 'utils';

// source: https://business.safety.google/adscookies/
var CookiesList = {
	necessary: [
		{
			provider: 'GrandVoyage',
			cookies: [
				{
					name: 'gv_cookie_config',
					description: 'Almacena esta configuración de cookies del usuario',
				},
				{
					name: 'csrftoken',
					description: 'Cookie de seguridad. Sin esta cookie el servidor no aceptara ninguna de tus peticiones POST.',
				},
				{
					name: 'sessionid',
					description: 'Cookie de sesión. Almacena la sesión del usuario.',
				},
			],
		},
	],
	anonanalytics: [
		{
			provider: 'GrandVoyage',
			cookies: [
				{
					name: 'user_uuid',
					description: 'Usado para identificar los caminos de los usuarios dentro del sitio web.',
				},
			],
		},
	],
	preferences: [
		{
			provider: 'GrandVoyage',
			cookies: [
				{
					name: 'guide_india',
					description: 'Usada para recordar si ya le hemos mostrado la opción de descargar la guía de la India.',
					storage: 'Session',
				},
				{
					name: 'guide_tailandia',
					description: 'Usada para recordar si ya le hemos mostrado la opción de descargar la guía de Tailandia.',
					storage: 'Session',
				},
				{
					name: 'guide_vietnam',
					description: 'Usada para recordar si ya le hemos mostrado la opción de descargar la guía de Vietnam.',
					storage: 'Session',
				},
			],
		},
	],
	marketing: [
		{
			provider: 'Google',
			cookies: [
				{
					name: '_ga',
					description: 'Usada para distinguir usuarios',
					storage: '2 años',
				},
				{
					name: '_ga_#',
					description: 'Usada para guardar el estado de la sesión',
					storage: '2 años',
				},
				{
					name: '_git',
					description: 'Utilizado por Google Analytics para controlar la tasa de peticiones',
					storage: '1 día',
				},
				{
					name: '_gid',
					description: 'Registra una identificación única que se utiliza para generar datos estadísticos acerca de cómo utiliza el visitante el sitio web.',
					storage: '1 día',
				},
				{
					name: 'IDE',
					description: '-',
					storage: '2 años',
				},
				{
					name: '_gcl_au',
					description: '-',
					storage: '90 días',
				},
				{
					name: '_gcl_aw',
					description: '-',
					storage: '90 días',
				},
				{
					name: 'SNID',
					description: '-',
					storage: '6 meses',
				},
				{
					name: 'NID',
					description: '-',
					storage: '6 meses',
				},
				{
					name: 'OGPC',
					description: '-',
					storage: '1 mes',
				},
				{
					name: 'DV',
					description: '-',
					storage: '1 día',
				},
				{
					name: 'SOCS',
					description: '-',
					storage: '13 meses',
				},
			],
		},
	],
	mysc: [
		{
			provider: 'Cetelem',
			cookies: [
				{
					name: 'ECREDITNOWID',
					description: '-',
				},
				{
					name: 'JSESSIONID',
					description: '-',
				},
				{
					name: 'LFR_SESSION_STATE_20120',
					description: '-',
				},
				{
					name: 'ROUTEID',
					description: '-',
				},
				{
					name: '_hjHasCachedUserAttributes',
					description: '-',
				},
				{
					name: '_hjSessionUser_1198973',
					description: '-',
				},
				{
					name: 'dtCookie',
					description: '-',
				},
			],
		},
		{
			provider: 'Bing',
			cookies: [
				{
					name: '_uetsid',
					description: '-',
				},
				{
					name: '_uetvid',
					description: '-',
				},
				{
					name: 'MUID',
					description: '-',
				},
			],
		},
		{
			provider: 'Spotify',
			cookies: [
				{
					name: 'sp_landing',
					description: '-',
				},
				{
					name: 'sp_t',
					description: '-',
				},
			],
		},
		{
			provider: 'Youtube',
			cookies: [
				{
					name: 'GPS',
					description: '-',
				},
				{
					name: 'VISITOR_INFO1_LIVE',
					description: '-',
				},
				{
					name: 'VISITOR_PRIVACY_METADATA',
					description: '-',
				},
			],
		},
	],
};



class CookieCategoryTab {
	constructor(category) {
		this.category = category;

		const container = document.querySelector(`#cookie-category-${category} .cookie-category-list`);
		if (container) {
			container.innerHTML = `
				${CookiesList[category].map(provider => `
					<div class="cookie-provider">
						<b class="cookie-provider-title">${provider.provider}</b>
						<div class="table-responsive">
							<table class="table" style="font-size: 1rem">
								<tr>
									<th>Cookie</th>
									<th>Caducidad</th>
									<th>Descripción</th>
								</tr>
								${provider.cookies.map(cookie => `
									<tr>
										<td>${cookie.name}</td>
										<td>${cookie.storage ? cookie.storage : '-'}</td>
										<td>
											${cookie.description}
										</td>
									</tr>
								`).join('')}
							</table>
						</div>
					</div>
				`).join('')}
			`;
		}

		const titles = document.querySelectorAll(`#cookie-category-${category} .cookie-provider-title`);
		titles.forEach(function (title) {
			title.addEventListener('click', function () {
				title.parentElement.classList.toggle('active');
			});
		});
	}

}


var GVCookieModal = {
	config: {
		acceptPreferences: true,
		acceptAnalytics: true,
		acceptMarketing: true,
	},

	open: false,
	config_ready: false,

	setCookie: function (session = false) {
		const value = JSON.stringify(this.config);
		setCookieOrSessionStorage('gv_cookie_config', value, 3650, session); // 10 years

		this.syncConfig();
		try { // In localhost, gtag is not loaded
			// eslint-disable-next-line no-undef
			dataLayer.push({'event': 'gv_consent_update'});
		} catch {
			console.log('Error updating google analytics');
		}
	},

	ajaxAction: function(action) {
		const csrf = document.getElementsByName('csrfmiddlewaretoken')[0]?.value || '';
		const body = new URLSearchParams({ csrfmiddlewaretoken: csrf, action: String(action) });
		fetch('/ajax/cookie_config_update/', {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body,
		}).catch(function () { /* noop */ });
	},

	acceptAll: function() {
		this.config = {
			acceptPreferences: true,
			acceptAnalytics: true,
			acceptMarketing: true,
		};

		this.setCookie();
		this.close();
		this.ajaxAction(2);
	},

	acceptSelection: function() {
		this.config = {
			acceptPreferences: document.getElementById('cookie-input-preferences').checked,
			acceptAnalytics: document.getElementById('cookie-input-analytics').checked,
			acceptMarketing: document.getElementById('cookie-input-marketing').checked,
		};

		this.setCookie();
		this.close();
		this.ajaxAction(1);
	},

	decline: function() {
		this.config = {
			acceptPreferences: false,
			acceptAnalytics: false,
			acceptMarketing: false,
		};

		this.setCookie(session=true);
		this.close();
		this.ajaxAction(0);
	},

	close: function() {
		const cookie = getCookieOrSessionStorage('gv_cookie_config');
		if (cookie) {
			const modal = document.getElementById('cookies-modal');
			if (modal) modal.style.display = 'none';
			this.open = false;
			return;
		}

		/* IF no configuration was accepted, we re-show the banner*/
		const modal = document.getElementById('cookies-modal');
		if (modal) modal.classList.remove('modal-version');
		const acceptBtn = document.getElementById('cookies-accept-selection-btn');
		if (acceptBtn) {
			const newBtn = document.createElement('button');
			newBtn.className = 'button is-outlined';
			newBtn.id = 'cookies-configure-btn';
			newBtn.textContent = 'Configurar';
			acceptBtn.replaceWith(newBtn);
			newBtn.addEventListener('click', function () { GVCookieModal.openConfiguration(); });
		}
		
		const info = document.getElementById('cookies-info');
		const configure = document.getElementById('cookies-configure');
		if (info) info.style.display = '';
		if (configure) configure.style.display = 'none';
	},

	setup: function() {
		const cookie = getCookieOrSessionStorage('gv_cookie_config');
		if (cookie) {
			this.config = JSON.parse(cookie);
			this.syncConfig();
			return;
		}

		const modal = document.getElementById('cookies-modal');
		if (modal) modal.style.display = '';
		this.open = true;
	},

	setup_config: function() {
		const configure = document.getElementById('cookies-configure');
		if (configure) configure.innerHTML = `
			<span class="modal-title">Uso de cookies</span>
			<div class="cookie-category" id="cookie-category-necessary">
				<div class="cookie-category-title">
					<b>Necesarias</b>
					<label class="switch">
					  <input type="checkbox" checked disabled>
					  <span class="slider round"></span>
					</label>
				</div>
				<p>
					Las cookies necesarias ayudan a hacer una página web utilizable activando funciones básicas como la navegación en la página y el acceso a áreas seguras de la página web. la página web no puede funcionar adecuadamente sin estas cookies.
				</p>

				<div class="cookie-category-list"></div>
			</div>

			<div class="cookie-category" id="cookie-category-anonanalytics">
				<div class="cookie-category-title">
					<b>Cookies analíticas anónimas</b>
					<label class="switch">
					  <input type="checkbox" checked disabled>
					  <span class="slider round"></span>
					</label>
				</div>
				<p>
					Estas cookies nos permiten contar las visitas y fuentes de circulación para poder medir y mejorar el desempeño de nuestro sitio. Nos ayudan a saber qué páginas son las más o menos populares, y ver cuántas personas visitan el sitio.
				</p>

				<div class="cookie-category-list"></div>
			</div>

			<div class="cookie-category" id="cookie-category-preferences">
				<div class="cookie-category-title">
					<b>Preferencias</b>
					<label class="switch">
					  <input type="checkbox" id="cookie-input-preferences" checked>
					  <span class="slider round"></span>
					</label>
				</div>
				<p>
					Las cookies de preferencias permiten a la página web recordar información que cambia la forma en que la página se comporta o el aspecto que tiene, como su idioma preferido o la región en la que usted se encuentra.
				</p>

				<div class="cookie-category-list"></div>
			</div>

			<div class="cookie-category" id="cookie-category-analytics">
				<div class="cookie-category-title">
					<b>Estadística</b>
					<label class="switch">
					  <input type="checkbox" id="cookie-input-analytics" checked>
					  <span class="slider round"></span>
					</label>
				</div>
				<p>
					Las cookies estadísticas ayudan a los propietarios de páginas web a comprender cómo interactúan los visitantes con las páginas web reuniendo y proporcionando información de forma anónima.
				</p>

				<div class="cookie-category-list"></div>
			</div>

			<div class="cookie-category" id="cookie-category-marketing">
				<div class="cookie-category-title">
					<b>Marketing</b>
					<label class="switch">
					  <input type="checkbox" id="cookie-input-marketing" checked>
					  <span class="slider round"></span>
					</label>
				</div>
				<p>
					Las cookies de marketing se utilizan para rastrear a los visitantes en las páginas web. La intención es mostrar anuncios relevantes y atractivos para el usuario individual, y por lo tanto, más valiosos para los editores y terceros anunciantes.
				</p>

				<div class="cookie-category-list"></div>
			</div>

			<div class="cookie-category" id="cookie-category-mysc">
				<div class="cookie-category-title">
					<b>Sin categorizar</b>
				</div>
				<p>
					Las cookies no clasificadas son cookies para las que todavía estamos en proceso de clasificar.
				</p>

				<div class="cookie-category-list"></div>
			</div>
			<br>
		`;
		this.config_ready = true;
	},

	openConfiguration: function() {
		this.open = true;

		const modal = document.getElementById('cookies-modal');
		if (modal) modal.classList.add('modal-version');
		const configureBtn = document.getElementById('cookies-configure-btn');
		if (configureBtn) {
			const newBtn = document.createElement('button');
			newBtn.className = 'button is-outlined';
			newBtn.id = 'cookies-accept-selection-btn';
			newBtn.textContent = 'Aceptar selección';
			configureBtn.replaceWith(newBtn);
		}
		
		if (!this.config_ready) {this.setup_config();}

		const info = document.getElementById('cookies-info');
		const configure = document.getElementById('cookies-configure');
		if (info) info.style.display = 'none';
		if (configure) configure.style.display = '';

		if (modal) modal.style.display = '';

		const acceptBtn = document.getElementById('cookies-accept-selection-btn');
		if (acceptBtn) acceptBtn.addEventListener('click', function () { GVCookieModal.acceptSelection(); });

		for (const category in CookiesList) {
			new CookieCategoryTab(category);
		}
	},

	syncConfig: function() {
		const pref = document.getElementById('cookie-input-preferences');
		const anal = document.getElementById('cookie-input-analytics');
		const mark = document.getElementById('cookie-input-marketing');
		if (pref) pref.checked = this.config.acceptPreferences;
		if (anal) anal.checked = this.config.acceptAnalytics;
		if (mark) mark.checked = this.config.acceptMarketing;
	}
};


// TODO: At some point this whole object should be reworked to be a proper Alpine module
// but for now it's a quick fix to get the cookies modal working with Alpine
export default () => ({
	cookiesObject: GVCookieModal,
	open: false,

	updateModalState() {
		if (this.cookiesObject.open !== this.open) {
			this.open = this.cookiesObject.open;
			this.$dispatch('modal-update', this.open ? 'open' : 'close');
		}
	},

	openConfiguration() {
		this.cookiesObject.openConfiguration();
		this.updateModalState();
	},

	init() {
		const self = this;
		const cfgBtn = document.getElementById('cookies-configure-btn');
		if (cfgBtn) cfgBtn.addEventListener('click', function () { self.cookiesObject.openConfiguration(); });

		const acceptBtn = document.getElementById('cookies-accept-btn');
		if (acceptBtn) acceptBtn.addEventListener('click', function () {
			self.cookiesObject.acceptAll();
			self.updateModalState();
		});

		const denyBtn = document.getElementById('cookies-deny-btn');
		if (denyBtn) denyBtn.addEventListener('click', function () {
			self.cookiesObject.decline();
			self.updateModalState();
		});


		/* Close modal on tap/click out */
		const content = document.querySelector('.cookies-modal-content');
		if (content) content.addEventListener('click', function (e) { e.stopPropagation(); });
		const modal = document.getElementById('cookies-modal');
		if (modal) modal.addEventListener('click', function () {
			self.cookiesObject.close();
			self.updateModalState();
		});

		this.cookiesObject.setup();
		this.updateModalState();
	},
	
});
